export class SRAOrdersLandingFilterVM {
  productName: string;
  itemNumber: string;
  accountName: string;
  accountNumber: string;
  requestID: string;
  status: string;
  cropYear: string;
  customerPO: string;
  webOrderNumber: string;
}
